import { callCep } from "../api";

export const getCep = async (cep) => {
  let address;

  const { data } = await callCep(cep);

  if (data?.error === true) {
    return {
      error: true,
      address: "",
    };
  }

  address = `${data.logradouro}, ${data.bairro}, ${data.localidade} — ${data.uf}`;

  return {
    error: false,
    address,
  };
};

export const getAddressByCep = async (cep) => {
  const { data } = await callCep(cep);

  if (!data || data.error === true) {
    return { error: true };
  }

  return {
    error: false,
    street: data.logradouro || "",
    neighborhood: data.bairro || "",
    city: data.localidade || "",
    state: data.uf || "",
  };
};
